const getCookies = (): Record<string, string> =>
    document.cookie.split('; ').reduce((acc, cur) => {
        const parts = cur.split('=');
        return { ...acc, [parts[0]]: parts[1] };
    }, {});

export { getCookies };